<template>
  <div class="contact-tab">
    <section class="section">
      <div class="container contact-grid">
        <div class="left reveal">
          <h1>联系我们</h1>
          <p>期待听到您的声音，我们的团队将竭诚为您解答任何数字化转型方面的疑问。</p>

          <article class="item">
            <div class="icon">📍</div>
            <div>
              <h3>公司地址</h3>
              <p>浙江省杭州市拱墅区蓝天商务中心1202室</p>
            </div>
          </article>

          <article class="item">
            <div class="icon">📞</div>
            <div>
              <h3>服务电话</h3>
              <p>总机: 0571-28113599</p>
              <p>客服: 15957621750</p>
            </div>
          </article>

          <article class="item">
            <div class="icon">✉</div>
            <div>
              <h3>邮箱及邮编</h3>
              <p>1637227159@qq.com</p>
              <p>310005</p>
            </div>
          </article>
        </div>

        <div class="form-card reveal">
          <h2>在线咨询</h2>
          <form @submit.prevent="handleSubmit" novalidate>
            <div class="grid">
              <label>
                <span>您的姓名</span>
                <input
                  v-model.trim="form.name"
                  :class="{ invalid: errors.name }"
                  :disabled="isSubmitting"
                  type="text"
                  placeholder="例如：张先生"
                  @blur="validateField('name')"
                />
                <small v-if="errors.name" class="field-error">{{ errors.name }}</small>
              </label>
              <label>
                <span>联系电话</span>
                <input
                  v-model.trim="form.phone"
                  :class="{ invalid: errors.phone }"
                  :disabled="isSubmitting"
                  type="tel"
                  placeholder="例如：138xxxx8888"
                  @blur="validateField('phone')"
                />
                <small v-if="errors.phone" class="field-error">{{ errors.phone }}</small>
              </label>
            </div>

            <label>
              <span>所属行业/单位</span>
              <select
                v-model="form.industry"
                :class="{ invalid: errors.industry }"
                :disabled="isSubmitting"
                @change="validateField('industry')"
              >
                <option disabled value="">请选择行业/单位</option>
                <option>政府部门</option>
                <option>国有企业</option>
                <option>商业综合体/物业</option>
                <option>其他</option>
              </select>
              <small v-if="errors.industry" class="field-error">{{ errors.industry }}</small>
            </label>

            <label>
              <span>咨询详情</span>
              <textarea
                v-model.trim="form.detail"
                :class="{ invalid: errors.detail }"
                :disabled="isSubmitting"
                rows="4"
                placeholder="请简单描述您的需求..."
                @blur="validateField('detail')"
              ></textarea>
              <small v-if="errors.detail" class="field-error">{{ errors.detail }}</small>
            </label>

            <button type="submit" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '提交申请' }}
            </button>
            <p v-if="submitMessage" :class="['submit-feedback', submitStatus]" aria-live="polite">
              {{ submitMessage }}
            </p>
          </form>
        </div>
      </div>
    </section>

    <!-- <section class="map reveal">
      <div class="container">
        <div class="map-wrap">
          <img src="/images/placeholders/contact-map.png" alt="公司地图占位图" />
          <div class="mark-card">
            <strong>中鸿云智总部</strong>
            <span>杭州·蓝天商务中心</span>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  name: 'ContactTab',
  data() {
    return {
      form: {
        name: '',
        phone: '',
        industry: '',
        detail: ''
      },
      errors: {
        name: '',
        phone: '',
        industry: '',
        detail: ''
      },
      isSubmitting: false,
      submitMessage: '',
      submitStatus: 'info'
    }
  },
  methods: {
    validateField(field) {
      const value = this.form[field]
      if (field === 'name') {
        this.errors.name = value ? '' : '请输入您的姓名'
      }
      if (field === 'phone') {
        this.errors.phone = /^1\d{10}$/.test(value) ? '' : '请输入正确的 11 位手机号'
      }
      if (field === 'industry') {
        this.errors.industry = value ? '' : '请选择所属行业/单位'
      }
      if (field === 'detail') {
        this.errors.detail = value.length >= 8 ? '' : '咨询详情至少 8 个字'
      }
    },
    validateForm() {
      this.validateField('name')
      this.validateField('phone')
      this.validateField('industry')
      this.validateField('detail')
      return !Object.values(this.errors).some(Boolean)
    },
    mockSubmit() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (Math.random() < 0.85) {
            resolve()
          } else {
            reject(new Error('network'))
          }
        }, 1200)
      })
    },
    async handleSubmit() {
      if (this.isSubmitting) return
      this.submitMessage = ''
      this.submitStatus = 'info'
      if (!this.validateForm()) {
        this.submitMessage = '请先完善必填信息后再提交。'
        this.submitStatus = 'error'
        return
      }
      this.isSubmitting = true
      try {
        await this.mockSubmit()
        this.submitMessage = '提交成功，我们会尽快与您联系。'
        this.submitStatus = 'success'
        this.form = { name: '', phone: '', industry: '', detail: '' }
        this.errors = { name: '', phone: '', industry: '', detail: '' }
      } catch (e) {
        this.submitMessage = '提交失败，请稍后重试。'
        this.submitStatus = 'error'
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped lang="less">
@primary: #2f67ea;

.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.section {
  padding: 56px 0 28px;
}

.contact-grid {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 20px;
}

.left h1 {
  margin: 0 0 8px;
  font-size: clamp(32px, 3.8vw, 48px);
}

.left > p {
  margin: 0;
  color: #5d7692;
  line-height: 1.8;
}

.item {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 12px;
  transition: background 0.2s ease, transform 0.2s ease;
}

.icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #e6f0ff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.item h3 {
  margin: 2px 0 6px;
  font-size: 22px;
}

.item p {
  margin: 0;
  color: #607996;
  line-height: 1.65;
}

.item:hover {
  background: #f1f6ff;
  transform: translateX(3px);
}

.form-card {
  border: 1px solid #dbe5f7;
  border-radius: 24px;
  background: #fff;
  padding: 20px;
  box-shadow: 0 12px 24px rgba(19, 50, 98, 0.12);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.form-card h2 {
  margin: 0 0 12px;
  font-size: clamp(26px, 2.6vw, 34px);
}

label {
  display: block;
  margin-bottom: 12px;
}

label span {
  display: block;
  margin-bottom: 6px;
  font-weight: 700;
  color: #24405f;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

input,
select,
textarea {
  width: 100%;
  min-height: 46px;
  border-radius: 13px;
  border: 1px solid #dce6f7;
  background: #f4f7fc;
  color: #243c5a;
  padding: 0 12px;
  outline: none;
}

textarea {
  min-height: 130px;
  resize: vertical;
  padding-top: 10px;
}

input:focus,
select:focus,
textarea:focus {
  border-color: @primary;
  box-shadow: 0 0 0 3px rgba(47, 103, 234, 0.14);
}

.field-error {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #d93025;
}

input.invalid,
select.invalid,
textarea.invalid {
  border-color: #ef7267;
}

button[type='submit'] {
  width: 100%;
  min-height: 52px;
  border: 0;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(135deg, #2f67ea 0%, #2f5fd3 100%);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

button[type='submit']:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 22px rgba(31, 73, 164, 0.25);
}

button[type='submit'][disabled] {
  cursor: not-allowed;
  opacity: 0.75;
  transform: none;
  box-shadow: none;
}

.submit-feedback {
  margin: 10px 2px 0;
  font-size: 13px;
  line-height: 1.6;
}

.submit-feedback.success {
  color: #1f8f4f;
}

.submit-feedback.error {
  color: #d93025;
}

.submit-feedback.info {
  color: #49688b;
}

.map {
  padding: 22px 0 18px;
}

.map-wrap {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  border: 1px solid #dce6f7;
}

.map-wrap img {
  width: 100%;
  display: block;
}

.mark-card {
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #d7e5fb;
  padding: 10px 12px;
  animation: markerFloat 3.8s ease-in-out infinite;
}

.mark-card strong {
  display: block;
  color: #193665;
}

.mark-card span {
  display: block;
  font-size: 12px;
  color: #6f84a2;
}

.map-wrap:hover .mark-card {
  animation-play-state: paused;
}

.form-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 30px rgba(19, 50, 98, 0.16);
}

@keyframes markerFloat {
  0% { transform: translate(-50%, -50%); }
  50% { transform: translate(-50%, -56%); }
  100% { transform: translate(-50%, -50%); }
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .contact-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .left > p,
  .item p {
    font-size: 14px;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
